//import React from "react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleSearchSRfun, handleSearchByCanId } from "../../../src/function";
import loader from "../../assets/Images/loader.gif";
// import Swal from 'sweetalert2';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const CustomerSR = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // This line disable the blue border
      boxShadow: "none",
    }),
  };
  const [searchCANId, setSearchCANId] = useState("");
  const [searchNumber, setSearchNumber] = useState("");
  const [searchSR, setSearchSR] = useState("");
  const [filterCANidData, setFilterCANidData] = useState(null);
  const [filterSRData, setFilterSRData] = useState(null);
  const [filterSRbyNo, setFilterSRbyNo] = useState(null);
  const [filterPhoneNum, setFilterPhoneNum] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [filterSRbyAccount, setFilterSRbyAccount] = useState(null);

  const handleSearchCANId = async () => {
    try {
      setLoading(true);
      let searchByCanId = await handleSearchByCanId(searchCANId);
      // setFilterCANidData(searchByCanId.Response);
      let srList = await handleSearchSRfun(searchCANId);
      if (
        searchByCanId.Response.status !== "failure" &&
        srList.Response.status !== "failure"
      ) {
        // Matching data found, update state
        setFilterSRData(srList.Response);
        setFilterCANidData(searchByCanId.Response);
        setFilterSRbyNo("");
        setFilterPhoneNum(null);
          setDropdownOptions("");

          setFilterSRbyAccount(null);
      } else {
        toast.warning("Not Available", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
          className: "",
        });
      }
    } catch (error) {
      //console.error('Error fetching data:', error);
      toast.warning("Not Available", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
        className: "",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSearchSR = async () => {
    try {
      setLoading(true);
      let srList = await handleSearchSRfun(searchCANId, searchSR);
      if (srList.Response && srList.Response.length > 0) {
        // Matching data found, update state
        setFilterSRbyNo(srList.Response);
        setFilterSRData("");
        setFilterCANidData("");
        setFilterPhoneNum(null);

          setFilterSRbyAccount(null);
      } else {
        // No matching data found for the SR number
        toast.warning("Not Available", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSearchPhone = async () => {
    try {
      setLoading(true);
      const url3 = process.env.REACT_APP_API_URL;
      const data3 = {
        Action: "getAccountDataIVR",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        CANID: "",
        Phone: searchNumber,
      };
      const response3 = await fetch(url3, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data3),
      });

      const result3 = await response3.json();
      if (response3.ok) {
        if (result3.Response && result3.Response.length > 0) {
          // Data found, update state and proceed to SR data retrieval
          setFilterPhoneNum([result3.Response[0]]);
          setDropdownOptions(result3.Response);
        //   setFilterSRbyNo("");
        // setFilterSRData("");
        // setFilterCANidData("");
          const extractedCanId = result3.Response[0].accountId;

          const url4 = process.env.REACT_APP_API_URL;
          const data4 = {
            Action: "getSRStatusIVR",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            CANID: extractedCanId,
            SRNo: "",
          };
          const response4 = await fetch(url4, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data4),
          });

          const result4 = await response4.json();
          if (response4.ok) {
            setFilterSRbyAccount(result4.Response);
            setFilterSRbyNo("");
            setFilterSRData("");
            setFilterCANidData("");
          } else {
            // Handle error for the second API call
            toast.error("Error fetching SR data", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } else {
          // No matching data found for the phone number
          toast.warning("Not Available", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
      } else {
        // Handle error for the first API call
        toast.error("Error fetching account data", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeSelectedAccount = async (selectAccount) => {
    //console.log("account number", event.target.value);
    setSelectedAccount(selectAccount);
    let selectedValue = dropdownOptions.find(
      (item) => item.accountId === selectAccount.value
    );

    if (selectedValue) {
      const extractedCanId = selectedValue.accountId;
      //console.log("CANID:", extractedCanId);
      try {
        // Fetch Account Details
        const url = process.env.REACT_APP_API_URL;
        const data = {
          Action: "getAccountDataIVR",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          CANID: extractedCanId,
          Phone: "",
        };
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        const result = await response.json();
        //console.log("Account Details :", result);
        setFilterPhoneNum([result.Response[0]] || []);

        // Fetch SR Data
        const urlSR = process.env.REACT_APP_API_URL;
        const dataSR = {
          Action: "getSRStatusIVR",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          CANID: extractedCanId,
          SRNo: "",
        };
        const responseSR = await fetch(urlSR, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataSR),
        });
        const resultSR = await responseSR.json();
        //console.log("SR Details :", resultSR);
        setFilterSRbyAccount(resultSR.Response);
      } catch (error) {
        //console.error('Error fetching data:', error);
      }
    }
  };

  // const accountNames =
  //   dropdownOptions?.map((account) => ({
  //     accountName: account.accountName,
  //     accountNo: account.accountNo,
  //     accountId: account.accountId,
  //   })) || [];

    const accountNames = Array.isArray(dropdownOptions)
  ? dropdownOptions.map((account) => ({
      accountName: account.accountName,
      accountNo: account.accountNo,
      accountId: account.accountId,
    }))
  : [];

  const handleEmptyInput =()=>{
    setSearchCANId("");
    setSearchNumber("");
    setSearchSR("");
  }


  const navigate = useNavigate();
  const redirectDashboardPage = () => {
    navigate("/dashboard");
  };

  return (
    <>
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectDashboardPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3"> Search Customer SR</span>
        </div>
      </div>

      {/* ***********************search bar *********************** */}
      <div className=" container-fluid" style={{ marginTop: "65px" }}>
        <div className="accordion" id="accordionExample">
          <div className="row">
            <div className="col-md-4">
              <div className="accordion-item ">
                <span className="accordion-header " id="headingOne" onClick={handleEmptyInput}>
                  <span
                    className="accordion-button "
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Search Account
                  </span>
                </span>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <div className="inputs-container">
                      <i className="fa fa-search text-secondary"></i>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search Account"
                        value={searchCANId}
                        onChange={(e) => setSearchCANId(e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn btn-sm"
                        onClick={handleSearchCANId}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="accordion-item">
                <span className="accordion-header" id="headingTwo" onClick={handleEmptyInput}>
                  <span
                    className="accordion-button collapsed "
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Search SR
                  </span>
                </span>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <div className="inputs-container">
                      <i className="fa fa-search text-secondary"></i>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search SR"
                        value={searchSR}
                        onChange={(e) => setSearchSR(e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn btn-sm"
                        onClick={handleSearchSR}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="accordion-item">
                <span className="accordion-header" id="headingThree" onClick={handleEmptyInput}>
                  <span
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Search With Mobile Number
                  </span>
                </span>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <div className="inputs-container">
                      <i className="fa fa-search text-secondary"></i>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Search With Mobile Number"
                        maxLength="10"
                        pattern="[0-9]{10}"
                        value={searchNumber}
                        onChange={(e) => setSearchNumber(e.target.value)}
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ];
                          const isDigit = /\d/.test(e.key);
                          // Allow the input if the key pressed is a digit or an allowed key
                          // and the input length is less than 10,
                          // or if the key pressed is the backspace key and the input length is greater than 0
                          if (
                            (isDigit || allowedKeys.includes(e.key)) &&
                            (searchNumber.length < 10 || e.key === "Backspace")
                          ) {
                            return true;
                          } else {
                            e.preventDefault();
                          }
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-sm"
                        onClick={handleSearchPhone}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* *************Search by CanId************ */}
      {/* *************Account details****************** */}
      <div className="container-fluid">
        <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-1">
          <div className="col">
            <div className=" mb-3 mt-3 ">
              <div
                className=" d-flex justify-content-center"
                style={{ display: "inline-flex" }}
              >
                {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                      <img src={loader} alt="loading...."></img>
                    </div>
                  </div>
                ) : filterCANidData ? (
                  <div className="col-12 col-md-6 border-color p-2">
                    {/* Render filtered data here */}
                    <div
                      className="text-style text-center mb-4 text-secondary"
                      style={{ fontWeight: "700" }}
                    >
                      Account Details
                    </div>
                    {filterCANidData.map((item, index) => (
                      <div key={index}>
                        <div className="row mt-1">
                          <div className="col-4 text-weight-color" style={{whiteSpace:"nowrap"}}>Account Name</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{item.accountName}</div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-4 text-weight-color">Account No</div>
                          <div className="col-1">:</div>
                          <div className="col-7 text-color">{item.accountNo}</div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-4 text-weight-color">Address</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{item.address}</div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-4 text-weight-color">Email</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{item.email}</div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-4 text-weight-color">Mobile No</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{item.mobileno}</div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-4 text-weight-color" style={{whiteSpace:"nowrap"}}>Due Amount</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{item.balance}</div>
                        </div>
                        
                      </div>
                    ))}
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ***************last 5 SR****************** */}
      {filterSRData  ? (
        <div className="container-fluid">
          <div className="text-center p-2 bg-light">
            <div
              className="text-secondary text-style"
              style={{ fontWeight: "700" }}
            >
              Last 5 SR
            </div>
          </div>
          <div className="row mt-2 row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
            {filterSRData.map((item, index) => (
              <div className="col" key={index}>
                <div className="card mb-3">
                  <div
                    className="m-3 d-flex"
                    style={{ display: "inline-flex" }}
                  >
                    <div className="data-container">
                      <p>
                        <strong>Created on :</strong>
                        <span className="text-color"> {item.modifiedon}</span>
                      </p>
                      <p>
                        <strong>Status : </strong>{" "}
                        <span className="text-color"> {item.status} </span>
                      </p>
                      <p>
                        <strong>Service Id : </strong> {item.CanId}
                      </p>
                      <p>
                        <strong>SR Number : </strong> {item.srNumber}
                      </p>
                      <p>
                        <strong>State code : </strong> {item.statecode}
                      </p>
                      <p>
                        <strong>Case source : </strong> {item.casesource}
                      </p>
                      <p>
                        <strong>Case category : </strong> {item.casecategory}
                      </p>
                      <p>
                        <strong>Creation Type : </strong> {item.creationType}
                      </p>
                      <p>
                        <strong>Creation SubType : </strong>{" "}
                        {item.creationSubType}
                      </p>
                      <p>
                        <strong>Creation SubSubType : </strong>{" "}
                        {item.creationSubSubType}
                      </p>
                      <p>
                        <strong>Closure RFO : </strong> {item.closureRfo}
                      </p>
                      <p>
                        <strong>Closure RC1 : </strong>
                        <span className="text-color">
                          {item.closurecategoryRC1}
                        </span>
                      </p>
                      <p>
                        <strong>Closure RC2 : </strong>
                        <span className="text-color">
                          {" "}
                          {item.closureSubCategoryRC2}
                        </span>
                      </p>
                      <p>
                        <strong>Closure RC3 : </strong>
                        <span className="text-color">
                          {" "}
                          {item.closureSubSubCategoryRC3}
                        </span>
                      </p>
                      <p>
                        <strong>ETR : </strong> {item.ETR}
                      </p>
                      <p>
                        <strong>EXETR : </strong> {item.ExETR}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {/* ***************single SR filtered data****************** */}
      <div className="container-fluid" style={{ marginTop: "-25px" }}>
        <div className="row">
          <div className="col-md-4"></div>
          <div className="col-md-4">
            {filterSRbyNo ? (
              <div className="card p-3">
                {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                      <img src={loader} alt="loading...."></img>
                    </div>
                  </div>
                ) : (
                  filterSRbyNo.map((item, index) => (
                    <div key={index}>
                      <p>
                        <strong>Created on :</strong>
                        <span className="text-color"> {item.modifiedon}</span>
                      </p>
                      <p>
                        <strong>Status : </strong>{" "}
                        <span className="text-color"> {item.status} </span>
                      </p>
                      <p>
                        <strong>Service Id : </strong> {item.CanId}
                      </p>
                      <p>
                        <strong>SR Number : </strong> {item.srNumber}
                      </p>
                      <p>
                        <strong>State code : </strong> {item.statecode}
                      </p>
                      <p>
                        <strong>Case source : </strong> {item.casesource}
                      </p>
                      <p>
                        <strong>Case category : </strong> {item.casecategory}
                      </p>
                      <p>
                        <strong>Creation Type : </strong> {item.creationType}
                      </p>
                      <p>
                        <strong>Creation SubType : </strong>{" "}
                        {item.creationSubType}
                      </p>
                      <p>
                        <strong>Creation SubSubType : </strong>{" "}
                        {item.creationSubSubType}
                      </p>
                      <p>
                        <strong>Closure RFO : </strong> {item.closureRfo}
                      </p>
                      <p>
                        <strong>Closure RC1 : </strong>
                        <span className="text-color">
                          {item.closurecategoryRC1}
                        </span>
                      </p>
                      <p>
                        <strong>Closure RC2 : </strong>
                        <span className="text-color">
                          {" "}
                          {item.closureSubCategoryRC2}
                        </span>
                      </p>
                      <p>
                        <strong>Closure RC3 : </strong>
                        <span className="text-color">
                          {" "}
                          {item.closureSubSubCategoryRC3}
                        </span>
                      </p>
                      <p>
                        <strong>ETR : </strong> {item.ETR}
                      </p>
                      <p>
                        <strong>EXETR : </strong> {item.ExETR}
                      </p>
                    </div>
                  ))
                )}
              </div>
            ) : (
              <p></p>
            )}
          </div>
          <div className="col-md-4"></div>
        </div>
      </div>

      {/* *************Search by Phone Number********** */}
      {/* *************Account details****************** */}
      <div className="container-fluid" style={{ marginTop: "-20px" }}>
        <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-1">
          <div className="col">
            <div className=" mb-3 ">
              <div className=" d-flex justify-content-center">
                {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                      <img src={loader} alt="loading...."></img>
                    </div>
                  </div>
                ) : filterPhoneNum ? (
                  <div className="col-12 col-md-6 ">
                    {/* <select
                  className="form-select form-select-sm" aria-label=".form-select-sm example"
                  value={selectedAccount}
                  onChange={handleChangeSelectedAccount}>
                    {accountNames.map((item, index) => (
                      <option key={index} value={item.accountId}>
                    {item.accountId} ({item.accountName}) ({item.accountNo})
                  </option>
                  ))}
                </select> */}
                    <Select
                      className="basic-single form-control form-control-sm"
                      classNamePrefix="select"
                      name="CustContactable"
                      placeholder="Select Account"
                      styles={style}
                      value={selectedAccount}
                      isSearchable={false}
                      onChange={handleChangeSelectedAccount}
                      options={accountNames.map((data) => ({
                        value: data.accountId,
                        label: `${data.accountId} (${data.accountName}) (${data.accountNo})`,
                      }))}
                    />

                    <div className="mt-2 p-2 border-color">
                      <div
                        className="text-style text-center mb-4 text-secondary"
                        style={{ fontWeight: "700" }}
                      >
                        Account Details
                      </div>
                      {filterPhoneNum.map((item, index) => (
                        <div key={index}>
                          
                          <div className="row mt-1">
                          <div className="col-4 text-weight-color" style={{whiteSpace:"nowrap"}}>Account Name</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{item.accountName}</div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-4 text-weight-color" style={{whiteSpace:"nowrap"}}>Account No.</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{item.accountNo}</div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-4 text-weight-color" style={{whiteSpace:"nowrap"}}>Address</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{item.address}</div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-4 text-weight-color" style={{whiteSpace:"nowrap"}}>Email</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{item.email}</div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-4 text-weight-color" style={{whiteSpace:"nowrap"}}>Mobile No</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{item.mobileno}</div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-4 text-weight-color" style={{whiteSpace:"nowrap"}}>Due Amount</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{item.balance}</div>
                        </div>
                       
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ***********last 5 SR*********** */}
      {Array.isArray(filterSRbyAccount) && filterSRbyAccount.length > 0 ? (
        <div className="container-fluid">
          <div className="text-center p-2 bg-light">
            <div
              className="text-secondary text-style"
              style={{ fontWeight: "700" }}
            >
              Last 5 SR
            </div>
          </div>
          <div className="row mt-2 row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
            {Array.isArray(filterSRbyAccount) && filterSRbyAccount.map((item, index) => (
              <div className="col" key={index}>
                <div className="card mb-3">
                  <div
                    className="m-3 d-flex"
                    style={{ display: "inline-flex" }}
                  >
                    <div className="data-container">
                      <p>
                        <strong>Created on :</strong>
                        <span className="text-color"> {item.modifiedon}</span>
                      </p>
                      <p>
                        <strong>Status : </strong>{" "}
                        <span className="text-color"> {item.status} </span>
                      </p>
                      <p>
                        <strong>Service Id : </strong> {item.CanId}
                      </p>
                      <p>
                        <strong>SR Number : </strong> {item.srNumber}
                      </p>
                      <p>
                        <strong>State code : </strong> {item.statecode}
                      </p>
                      <p>
                        <strong>Case source : </strong> {item.casesource}
                      </p>
                      <p>
                        <strong>Case category : </strong> {item.casecategory}
                      </p>
                      <p>
                        <strong>Creation Type : </strong> {item.creationType}
                      </p>
                      <p>
                        <strong>Creation SubType : </strong>{" "}
                        {item.creationSubType}
                      </p>
                      <p>
                        <strong>Creation SubSubType : </strong>{" "}
                        {item.creationSubSubType}
                      </p>
                      <p>
                        <strong>Closure RFO : </strong> {item.closureRfo}
                      </p>
                      <p>
                        <strong>Closure RC1 : </strong>
                        <span className="text-color">
                          {item.closurecategoryRC1}
                        </span>
                      </p>
                      <p>
                        <strong>Closure RC2 : </strong>
                        <span className="text-color">
                          {" "}
                          {item.closureSubCategoryRC2}
                        </span>
                      </p>
                      <p>
                        <strong>Closure RC3 : </strong>
                        <span className="text-color">
                          {" "}
                          {item.closureSubSubCategoryRC3}
                        </span>
                      </p>
                      <p>
                        <strong>ETR : </strong> {item.ETR}
                      </p>
                      <p>
                        <strong>EXETR : </strong> {item.ExETR}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default CustomerSR;
